const styles = theme => ({
    flex: {
        flex: 1
    },
    appBar: {
        position: 'static'
    },
    contentRoot: {
        padding: 50,
        minWidth: 250
    },    
    dropdown: {
        minWidth: 200
    }
});

export default styles;